var _style, _path, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CED1D2;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#CED1D2;stroke:#262727;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#CED1D2;stroke:#313130;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:#262727;}\n\t.st4{fill:#FFFFFF;stroke:#262727;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0971,6.084;}\n\t.st8{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:none;stroke:#262727;stroke-width:3.5104;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#262727;stroke-width:5.2656;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#262727;stroke-width:3.3321;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#262727;stroke-width:2;stroke-miterlimit:10;}\n\t.st15{fill:#FFFFFF;stroke:#262727;stroke-width:2.2376;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#262727;stroke-width:3.9275;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#262727;stroke-width:2.6183;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:none;}\n\t.st19{fill:none;stroke:#262727;stroke-width:2.6737;stroke-linecap:round;stroke-linejoin:round;}\n\t.st20{fill:none;stroke:#262727;stroke-width:2.6737;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0781,5.4695;}\n\t.st21{fill:none;stroke:#262727;stroke-width:1.7825;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st22{fill:#262727;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st24{fill:#FFFFFF;stroke:#262727;stroke-width:4.0567;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#262727;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#262727;stroke-width:5.2656;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#262727;stroke-width:3.5848;stroke-linecap:round;stroke-linejoin:round;}\n\t.st28{fill:none;stroke:#262727;stroke-width:3.5848;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1048,7.3331;}\n\t.st29{fill:none;stroke:#262727;stroke-width:3.7276;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st30{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0616,6.2618;}\n\t.st31{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0775,5.8457;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.99,236.22V122.24l103.05-84.78c0,0,6.02-4.07,14.99-4.07s13.85,3.84,13.85,3.84l103.9,84.85v114.14H23.99z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 51.41,
    transform: "matrix(0.9398 -0.3418 0.3418 0.9398 -22.5397 53.8571)",
    className: "st5",
    width: 185.46,
    height: 78.96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.76,71.81c-2.23,0.82-3.38,3.3-2.56,5.53c0.82,2.23,3.3,3.38,5.53,2.56c2.23-0.82,3.38-3.3,2.56-5.53 C112.47,72.14,109.99,70.99,107.76,71.81"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "89.35,79.8 111.53,101.85 111.77,92.66 96.26,77.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "75.53,84.88 97.71,106.93 97.95,97.75 82.44,82.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "58.4,91.18 68.05,117.41 87.25,110.36 82.46,105.6 71.99,109.45 64.46,88.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 148.64,
    y1: 129.31,
    x2: 148.63,
    y2: 129.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st31",
    x1: 146.62,
    y1: 123.78,
    x2: 123.24,
    y2: 59.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 122.24,
    y1: 57.02,
    x2: 122.22,
    y2: 56.98
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 134.96,
    y1: 64.08,
    x2: 210.07,
    y2: 36.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 139.61,
    y1: 76.86,
    x2: 214.72,
    y2: 49.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.26,
    y1: 89.64,
    x2: 219.37,
    y2: 62.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 148.91,
    y1: 102.41,
    x2: 187.51,
    y2: 88.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 153.79,
    y1: 115.82,
    x2: 172.21,
    y2: 109.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 210.48,
    y1: 95.18,
    x2: 228.9,
    y2: 88.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 129.38,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -42.145 34.6636)",
    className: "st3",
    width: 3.11,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.69,
    y: 127.18,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -41.0311 36.5929)",
    className: "st3",
    width: 3.11,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.02,
    y: 120.15,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -37.4602 42.7779)",
    className: "st3",
    width: 3.11,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.09,
    y: 111.75,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -33.197 50.162)",
    className: "st3",
    width: 3.11,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.61,
    y: 113.74,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -34.209 48.4092)",
    className: "st3",
    width: 3.11,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.46,
    y: 118.17,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -36.4552 44.5185)",
    className: "st3",
    width: 3.11,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.54,
    y: 124.99,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -39.9189 38.5194)",
    className: "st3",
    width: 5.46,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.79,
    y: 122.35,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -38.5787 40.8406)",
    className: "st3",
    width: 5.46,
    height: 14.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.33,
    y: 115.97,
    transform: "matrix(0.9397 -0.342 0.342 0.9397 -35.3367 46.4559)",
    className: "st3",
    width: 5.46,
    height: 14.93
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: 122.24,
    className: "st3",
    width: 235.8,
    height: 113.98
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/post-icon.59eb0db836e48e0190651f03036546de.svg";
export { ForwardRef as ReactComponent };